import { render, staticRenderFns } from "./MetricasCampanhaOficialView.vue?vue&type=template&id=388b2666&scoped=true"
import script from "./MetricasCampanhaOficialView.vue?vue&type=script&lang=js"
export * from "./MetricasCampanhaOficialView.vue?vue&type=script&lang=js"
import style0 from "./MetricasCampanhaOficialView.vue?vue&type=style&index=0&id=388b2666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388b2666",
  null
  
)

export default component.exports